// third-party
import { combineReducers } from 'redux';

// project import
import menu from './menu';
import applications from './applications';
import snackbar from './snackbar';

// ==============================|| COMBINE REDUCERS ||============================== //

const reducers = combineReducers({
  menu,
  applications,
  snackbar
});

export default reducers;
